import { z } from "zod";

export const machineWarningSchema = z.object({
	message: z.string(),
	code: z.number(),
	arguments: z.array(z.number()),
});

export type MachineWarning = z.infer<typeof machineWarningSchema>;
